import axios from 'axios'
import { getEnvVariables } from '../helpers/getEnvVariables'
import { getAuthToken, getRefreshToken, saveTokens } from './authTokens'

const { QUOTER_URL } = getEnvVariables()

const REFRESH_PATH = '/authentication/mvc/login/agents/refresh'

const quoterApiInstance = axios.create({
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': '*',
    'Access-Control-Allow-Headers': 'Content-Type',
    baseURL: QUOTER_URL,
})

quoterApiInstance.interceptors.request.use((config) => {
    const token = getAuthToken();
    config.headers = {
        ...config.headers,
        ...(token && { Authorization: `Bearer ${token}` }),
    }
    return config
})

// Una sola renovación en vuelo: si varias peticiones reciben 401 a la vez, todas esperan
// la misma. El refresh token puede ser de un solo uso y renovarlo dos veces lo invalidaría.
let refreshPromise = null;

const refreshAccessToken = () => {
    if (!refreshPromise) {
        // axios "pelado" (no la instancia) para que un 401 del refresh no dispare este mismo interceptor.
        refreshPromise = axios
            .post(`${QUOTER_URL}${REFRESH_PATH}`, { refreshToken: getRefreshToken() })
            .then(({ data }) => {
                const { token, refreshToken } = data?.data ?? {};
                if (!token) throw new Error('Refresh response without token');
                saveTokens({ token, refreshToken });
                return token;
            })
            .finally(() => {
                refreshPromise = null;
            });
    }
    return refreshPromise;
};

quoterApiInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
        const original = error.config;

        // Sin refresh token (p. ej. agente que entra por link) no hay nada que renovar.
        // `_retry` evita un bucle si la petición reintentada vuelve a dar 401.
        if (error.response?.status !== 401 || !original || original._retry || !getRefreshToken()) {
            return Promise.reject(error);
        }
        original._retry = true;

        try {
            await refreshAccessToken();
        } catch (refreshError) {
            // Si el refresh falla no se fuerza el logout: el llamador recibe el 401 original.
            return Promise.reject(error);
        }

        // El interceptor de request vuelve a correr y toma el token nuevo.
        return quoterApiInstance(original);
    }
)

export default quoterApiInstance
